import { Doughnut, mixins } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  extends: Doughnut,
  props: {
    chart_data: {
      type: Array,
      default: null,
    },
  },
  mounted () {
    this.renderChart({
      labels: ['Green Foods', 'Yellow Foods', 'Red Foods'],
      datasets: [
        {
          backgroundColor: ['#669933', '#ffcc00', '#cc3333'],
          data: this.chart_data,
        },
      ],
    }, {
      legend: {
        display: false,
      },
      plugins: {
        datalabels: {
          formatter: (value, ctx) => {
            let sum = 0;
            let dataArr = ctx.chart.data.datasets[0].data;
            dataArr.map(data => {
              sum += data;
            });
            let percentage = Math.round(value * 100 / sum) + '%';
            return percentage;
          },
          color: '#fff',
          font: {
            weight: 'normal',
            size: 16,
          },
        },
      },
      cutoutPercentage: 33,
    })
  }
}
